// source web : https://dev.to/kevinleedrum/axios-tips-for-real-world-apps-3bo4

import axios from "axios";

const config = {
  // baseURL: import.meta.env.VITE_API_URL
  baseURL: process.env.VUE_APP_API_URL
};

const API = axios.create(config);
/*
const authentication = {
  login: (email, password ) => 
    API.post(
      `auth/local`,
      {
        identifier: email,
        password: password,
      }
    )
}
*/

const low_carbon_actions = {
  get: (params) => API.get(`low_carbon_actions?${params.filter}`),
};
const compagnies = {
  get: (params) => API.get(`compagnies?${params.filter}`),
};
const structure_type = {
  get: (params) => API.get(`structure_type?${params.filter}`),
};
const action_theme = {
  get: (params) => API.get(`action_theme?${params.filter}`),
};
const action_scope = {
  get: (params) => API.get(`action_scope?${params.filter}`),
};
const action_engagement = {
  get: (params) => API.get(`action_engagement?${params.filter}`),
};

export default {
  low_carbon_actions,
  compagnies,
  structure_type,
  action_theme,
  action_scope,
  action_engagement
};
